import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiService implements OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  constructor(private httpClient: HttpClient) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getData<T>(url: string): Observable<T> {
    return this.HttpGetRequest<T>(url);
  }

  public postData<T>(url: string, data: any): Observable<T> {
    return this.HttpPostRequest<T>(url, data);
  }

  public putData<T>(url: string, data: any): Observable<T> {
    return this.HttpPutRequest<T>(url, data);
  }

  public deleteData<T>(url: string): Observable<boolean | T> {
    return this.HttpDeleteRequest<T>(url);
  }

  public patchData<T>(url: string, data: any): Observable<T> {
    return this.HttpPatchRequest<T>(url, data);
  }

  private HttpGetRequest<T>(url: string): Observable<T> {
    return this.httpClient.get<T>(url).pipe(takeUntil(this.destroy$));
  }

  private HttpPutRequest<T>(url: string, t: T): Observable<T> {
    return this.httpClient.put<T>(url, t).pipe(takeUntil(this.destroy$));
  }

  private HttpPostRequest<T>(url: string, t: T): Observable<T> {
    return this.httpClient.post<T>(url, t).pipe(takeUntil(this.destroy$));
  }

  private HttpDeleteRequest<T>(url: string): Observable<boolean | T> {
    return this.httpClient.delete<T>(url).pipe(takeUntil(this.destroy$));
  }

  private HttpPatchRequest<T>(url: string, t: T): Observable<T> {
    return this.httpClient.patch<T>(url, t).pipe(takeUntil(this.destroy$));
  }
}
